import moment from "moment";
import { createSelector } from "reselect";
import { REMINDERS_SUPPORTED_PARENT_TYPES } from "~/components/Reminders/utils";
import { sortCompare } from "~/utils/utils.jsx";

export const getReminders = (state) => state.reminders;

export const getRemindersArray = createSelector(getReminders, (reminders) => Object.values(reminders));

export const getReminderById = createSelector(
  getReminders,
  (state, id) => id,
  (reminders, id = 0) => reminders[id]
);

export const getRemindersByDate = createSelector(
  getRemindersArray,
  (state, date) => moment.utc(date).startOf("day"),
  (reminders, date) =>
    reminders
      .filter(
        (reminder) =>
          REMINDERS_SUPPORTED_PARENT_TYPES.includes(reminder.parent_type) &&
          reminder.subscribers?.length > 0 &&
          moment.unix(reminder.send_on ? reminder.send_on : reminder.remind_on).isSame(date, "day")
      )
      .sort((a, b) => sortCompare(a.created_on, b.created_on))
);

export const getRemindersByParent = createSelector(
  getRemindersArray,
  (_, parentType) => parentType,
  (_, __, parentId) => parentId,
  (reminders, parentType, parentId) =>
    reminders
      .filter(
        (reminder) =>
          reminder.parent_id === parentId && reminder.parent_type === parentType && reminder.subscribers?.length > 0
      )
      .sort((a, b) => sortCompare(a.created_on, b.created_on))
);
